module.exports = __webpack_public_path__ + "assets/images/project/uae.jpg?v=9dc81840";